import axios from "axios"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import serverConfig from '../../utilities/serverConfig.json'
import apiConfig from '../../utilities/apiConfig.json'

const getUserDataApiRoute = serverConfig.server.url1 + apiConfig.api.userControllers.getUserInfo
const tokenLocal = localStorage.getItem("token");

const UserDataAuth = () => {

    const dispatch = useDispatch()

    // useEffect(() => {
    //     (
    //         async () => {

    //             try {

    //                 const { data, status } = await axios.get(getUserDataApiRoute, {
    //                     headers: {
    //                         Authorization: `Bearer ${tokenLocal}`,
    //                         "Content-Type": 'applicatoin/json'
    //                     }
    //                 })

    //             } catch (error) { console.log(error) }

    //         }
    //     )()
    // }, [])

    return null
}

export default UserDataAuth